import { Content } from "pdfmake/interfaces";
import { OwnerDetailResponse } from "@app/shared/models/chip-details.model";

export function ownerInformation(owner: OwnerDetailResponse | undefined): Content[] {
    return owner ? [
        {
            table: {
                widths: ['auto', '*', 'auto', '*'],
                body: [
                    [
                        { text: 'Emri dhe Mbiemri', border: [false, false, false, false] },
                        {
                            text: owner.fullName,
                            border: [false, false, false, true],
                        },
                        { text: 'Email', border: [false, false, false, false] },
                        {
                            text: owner.email,
                            border: [false, false, false, true],
                        },
                    ],
                    [
                        { text: 'ID e dokumentit', border: [false, false, false, false] },
                        {
                            text: owner.idNumber,
                            border: [false, false, false, true],
                        },
                        { text: 'Telefoni', border: [false, false, false, false] },
                        {
                            text: owner.phone,
                            border: [false, false, false, true],
                        },
                    ]
                ]
            }
        }
    ] : [];
}
